<template>
  <aside>
    <header class="d-flex flex-column">
      <b-button
          v-if="$gate.allow('create', 'project')"
          :to="{ name: 'projects.create' }"
          class="mb-3 align-self-end"
          variant="primary"
      >
        {{ $t('Create new project') }}

        <fa class="ml-1" icon="plus" />
      </b-button>

      <b-form @submit.prevent>
        <b-form-checkbox
            v-if="$gate.allow('restore', 'project')"
            v-model="params.show_deleted"
            value="1"
            unchecked-value="0"
        >
          {{ $t('Show deleted') }}
        </b-form-checkbox>

        <b-form-group
            :label="$t('Search')"
            label-for="projects-filter"
        >
          <b-input-group>
            <b-form-input
                id="projects-filter"
                v-model="search"
            />
            <b-input-group-append>
              <b-button @click="search = null">
                <fa :title="$t('Reset filter')" icon="times" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group
            :label="$t('Project number')"
            label-for="project_number_filter"
        >
          <b-form-input
              id="project_number_filter"
              v-model="params.project_number"
          />
        </b-form-group>

        <project-status-select v-model="params.status" />

        <b-form-group
            v-if="$gate.allow('viewAny', 'users')"
            :label="$t('Project manager')"
            label-for="project-manager-filter"
        >
          <project-manager-select
              id="project-manager-filter"
              v-model="projectManager"
              :resource-params="{projectManager: true}"
              resource="users"
              with-empty-value
              @input="params.project_manager_id = $event ? $event.id : null"
          />
        </b-form-group>

        <b-form-group
            v-if="$gate.allow('viewAny', 'users')"
            :label="$t('Construction manager')"
            label-for="construction-manager-filter"
        >
          <project-manager-select
              id="construction-manager-filter"
              v-model="constructionManager"
              :resource-params="{constructionManager: true}"
              resource="users"
              with-empty-value
              @input="params.construction_manager_id = $event ? $event.id : null"
          />
        </b-form-group>

        <b-form-group
            v-if="$gate.allow('viewAny', 'users')"
            :label="$t('Foreman')"
            label-for="foreman-filter"
        >
          <project-manager-select
              id="foreman-filter"
              v-model="foreman"
              :resource-params="{foreman: true}"
              resource="users"
              with-empty-value
              @input="params.foreman_id = $event ? $event.id : null"
          />
        </b-form-group>
      </b-form>
    </header>

    <spinner v-if="pending" class="my-3" />

    <b-list-group>
      <projects-list-item
          v-for="project in items"
          :key="project.id"
          :disabled="pending"
          :value="project"
      />
    </b-list-group>

    <no-results-found v-if="!pending && !totalRows" />

    <b-pagination
        v-if="showPagination"
        v-model="currentPage"
        :disabled="pending"
        :per-page="perPage"
        :total-rows="totalRows"
        align="fill"
        limit="3"
    />
  </aside>
</template>
<script>
import ProjectsListItem from '@/components/projects/ProjectsListItem';
import fetchPaginatedData from '@/mixins/fetchPaginatedData';
import ProjectManagerSelect from "@/components/selects/ResourceSelect";
import crudListener from "@/mixins/crudListener";
import ProjectStatusSelect from "@/components/selects/ProjectStatusSelect";
import Spinner from "@/components/Spinner";

export default {
  name: 'Projects',
  components: {Spinner, ProjectStatusSelect, ProjectManagerSelect, ProjectsListItem},
  mixins: [fetchPaginatedData, crudListener],
  data() {
    return {
      projectManager: null,
      constructionManager: null,
      foreman: null,
      search: null,
      params: {
        project_number: null,
        project_manager_id: null,
        construction_manager_id: null,
        foreman_id: null,
        show_deleted: 0,
        status: null
      }
    }
  },
  computed: {
    apiUrl() {
      return '/api/projects';
    },
  },


  created() {
    let _this = this;

    this.$root.$on('duplicated::projects', data => {
      let item = _this.items.find(item => item.parent_id = data.parent_id);

      if (!item) {
        return;
      }

      item.copies.push(data);
    })
  }
};
</script>

<style lang="scss" scoped>
header form {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;

  :nth-child(1) {
    grid-column: 1 / -1;
  }


  :nth-child(2) {
    grid-column: 1 / -1;
  }
}
</style>